import { useQuery } from 'urql';
import { Query, QueryStructureArgs } from 'api';
import { GET_STRUCTURE } from 'api/graphql/queries/structure';

export type QueryType = Pick<Query, 'structure'>;

export const useGetStructure = (variables: QueryStructureArgs) => {
    const [{ fetching, data, error }, reexecuteQuery] = useQuery<QueryType>({
        query: GET_STRUCTURE,
        variables,
        pause: !variables.id,
        requestPolicy: 'network-only',
    });

    return { fetching, data, error, reexecuteQuery };
};
